import { useMemo } from "react";
import { PrintData } from "../../../../../../printConfigration/PrintConfigration";
import { CustomerData } from "src/shared/services/interface";

export function usePrintData(
  order: any,
  outstandingBalance: number | string,
  clientId: string,
  arabicName: string,
  businessLocation: string,
  customer: CustomerData | any,
): PrintData {
  console.log(order, customer);

  return useMemo(() => {
    const paid =
      (order?.payments?.reduce((sum: number, i: any) => sum + (i.ReceivedAmount || 0), 0) || 0) < 0
        ? 0
        : order?.payments?.reduce((sum: number, i: any) => sum + (i.ReceivedAmount || 0), 0) || 0;

    return {
      CustomerName: order?.CustomerName || "",
      CustomerPhon: order?.CustomerPhoneNo?.toString() || "",
      OrderId: order?.Orderid || "",
      OrderStatus: order?.OrderStatus || "",
      Date: order?.Orderdate || "",
      Time: order?.Ordertime || "",
      Products: order?.Products || [],
      Paid: paid,
      unpaid: Math.max(0, Number(order?.RemainingAmount || 0)),
      OSB: outstandingBalance || 0,
      busnessName: sessionStorage.getItem("organization_name") || "",
      busnessArabicName: arabicName,
      businessLocation: businessLocation,
      phoneNum: sessionStorage.getItem("business_phone") || "",
      total: order?.totalAmount || 0,
      clientId: customer.clientId || clientId || "",
      discount: Number(order?.discount || 0),
      deliveryFee: Number(order?.deliveryFee || 0),
      subtotal: Number(order?.Finalamount || 0),
      billNo: order?.billNumber,
      paymentMethod: order?.payments?.map((p: any) => p.Paymentmethod).join(", ") || "",
    };
  }, [order, outstandingBalance, clientId, arabicName, businessLocation]);
}
